const c = {
  name: "AdyenForPlatformsLink",
  dimensions: { width: 40, height: 26 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 26" style="enable-background:new 0 0 40 26;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11.3,13c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C10.7,11.7,11.3,12.3,11.3,13z"
			/>
		<path class="st0" d="M21.3,13c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,11.7,21.3,12.3,21.3,13z"
			/>
		<path class="st0" d="M30,14.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C28.8,13.7,29.3,14.2,30,14.2z"
			/>
		<path class="st0" d="M0,13C0,5.8,5.8,0,13,0c2.6,0,5,0.7,7,2c2-1.3,4.4-2,7-2c7.2,0,13,5.8,13,13c0,7.2-5.8,13-13,13
			c-2.6,0-5-0.7-7-2c-2,1.3-4.4,2-7,2C5.8,26,0,20.2,0,13z M13,2C6.9,2,2,6.9,2,13c0,6.1,4.9,11,11,11c1.9,0,3.7-0.5,5.3-1.4
			C15.7,20.3,14,16.8,14,13s1.7-7.3,4.3-9.6C16.7,2.5,14.9,2,13,2z M16,13c0,3.4,1.6,6.5,4,8.5c2.4-2,4-5.1,4-8.5
			c0-3.4-1.6-6.5-4-8.5C17.6,6.5,16,9.6,16,13z M26,13c0,3.8-1.7,7.3-4.3,9.6c1.6,0.9,3.4,1.4,5.3,1.4c6.1,0,11-4.9,11-11
			c0-6.1-4.9-11-11-11c-1.9,0-3.7,0.5-5.3,1.4C24.3,5.7,26,9.2,26,13z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as AdyenForPlatformsLink
};
